import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import type { SalesProduct } from "../../types"

import { ProductStockType } from "@/graphql/codegen/graphql"

interface ProductCardProps {
  product: SalesProduct
}

export const ProductCard: FC<ProductCardProps> = ({ product }) => {
  const inStock = product.stockType === ProductStockType.StockItem

  return (
    <Box className='flex flex-1 items-center justify-between'>
      <Box className='flex h-8 flex-col justify-center'>
        <Typography className='text-base font-normal tracking-[0.15px] text-gray-800'>
          {product.vendorDescription ?? ""}
        </Typography>
        <Typography className='text-xs font-normal tracking-[0.4px] text-gray-800'>{product.publicId ?? ""}</Typography>
      </Box>
      <Box className='flex flex-col items-end'>
        <Typography className='text-sm font-normal leading-[120%] tracking-[0.15px] text-gray-800'>
          {product.company?.name ?? ""}
        </Typography>
        <Typography
          className={`text-sm font-normal leading-[120%] tracking-[0.15px] ${inStock ? "text-[#11A142]" : "text-gray-400"}`}
        >
          {inStock ? "In Stock" : "Out of Stock"}
        </Typography>
      </Box>
    </Box>
  )
}
